import { clsx } from 'clsx';
import { FC } from 'react';
import { LoadingIcon } from 'atoms/LoadingIcon';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './styles.module.css';

export const Loader: FC<{ className?: string; isCheckout?: boolean }> = ({
  className,
  isCheckout,
}) => {
  const t = useTranslations();
  return (
    <div className={clsx(styles.loaderBlock, className)}>
      <div
        className={clsx(styles.loaderBg, isCheckout && styles.loaderBgCheckout)}
      />
      <LoadingIcon
        text={t('common.site.loader')}
        classes={{
          icon: styles.icon,
          text: styles.text,
        }}
      />
    </div>
  );
};
